import batchUpload from './batchUpload'
import invitation from './invitation'
import candidate from './candidate'
import applicantList from './applicantList'
import candidateGroup from './candidateGroup'
import extension from './extension'

export default {
  batchUpload,
  invitation,
  candidate,
  applicantList,
  candidateGroup,
  extension
}
